<template>
  <el-select v-model="currentTaxonomy" :value="null" filterable>
    <el-option-group
      v-for="group in taxonomyGroups"
      :key="group.label"
      :label="group.label">
      <el-option
        v-for="(item, index) in group.options"
        :key="`${index}-${item.value}`"
        :label="item.label"
        :value="item.value" />
    </el-option-group>
  </el-select>
</template>

<script>
import json from './taxonomies.json';

export default {
  name: 'TaxonomySelect',
  data: () => ({
    taxonomies: json,
    taxonomySelection: [],
  }),
  props: {
    selectedTaxonomy: {
      type: String,
      default: null,
    },
  },
  computed: {
    currentTaxonomy: {
      get() {
        return this.selectedTaxonomy;
      },
      set(newTaxonomy) {
        this.$emit('onTaxonomyChanged', newTaxonomy);
      },
    },

    /**
     * Create a list of taxonomies sorted by the parent group it falls under.
     * For example a group 'Education' has a child 'Language Learning'
     *
     * @returns {Array<Object>}
     */
    taxonomyGroups() {
      return Object.keys(this.taxonomies).map(key => ({
        label: key,
        options: [
          { label: key, value: key },
          ...this.taxonomies[key].map(taxonomy => ({
            value: taxonomy,
            label: taxonomy,
          })),
        ],
      }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// TaxonomySelect.vue?5346db47